import { Select } from '@mantine/core'
import { InputWrapper } from 'App/data-export/components/DataExport/InputWrapper'
import { dataExportStore } from 'App/data-export/store/dataExportStore'
import { translate } from 'i18n/i18n'
import React, { useMemo } from 'react'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { checkAuthorization } from 'utils/checkAuthorization'
import { searchStringFromStringWithSpaces } from 'utils/searchStringFromStringWithSpaces'
import { sortByKey } from 'utils/sortByKey'

export const PropertySelect = () => {
  const state = dataExportStore.useSelector((s) => s)

  const data = useMemo(() => {
    return Object.entries(fieldAssetStore.getState().properties ?? {})
      .filter(([propertyId]) => checkAuthorization({ entity: propertyId, permission: 'EXPORT_DATA_TO_CSV' }))
      .map(([propertyId, p]) => ({ label: p.propertyName, value: propertyId }))
      .sort(sortByKey('label'))
  }, [])

  return (
    <InputWrapper
      label={translate.phrases.banyanApp('Select Property')}
      error={!!state.formErrors.propertyId}
      errorMessage={state.formErrors.propertyId}
    >
      <Select
        initiallyOpened={false}
        data={data}
        value={state.formState.propertyId}
        onChange={dataExportStore.actions.changePropertyId}
        searchable={true}
        placeholder={translate.phrases.banyanApp('Select Property')}
        filter={(value, item) => {
          return searchStringFromStringWithSpaces(value, item.label ?? '')
        }}
      />
    </InputWrapper>
  )
}
